import { useMutation, useQueryClient } from "react-query";
import { ActionLabel, Price } from "utils/types";

import client from "../../Client";

export interface ColumnPriceFormData {
    active: boolean;
    new: boolean;
    price_id: string;
    shop_id: string;
    category_id: string;
    kind_id: string;
    deactivated_labels: string[];
    action_labels: ActionLabel[];
}

export const useEditShopToPrice = () => {
    const queryClient = useQueryClient();

    return useMutation(
        ({ id, data }: { id: string; data: ColumnPriceFormData }) =>
            client.put(`/v1/shops-to-prices/${id}`, data).then((res) => res.data),
        {
            onMutate: async ({ id, data }) => {
                await queryClient.cancelQueries(["products", data.shop_id, "cannabis"]);
                const previousData = queryClient.getQueryData(["products", data.shop_id, "cannabis"]);

                queryClient.setQueryData(["products", data.shop_id, "cannabis"], (old: any) => {
                    if (!old) return old;
                    return {
                        ...old,
                        prices: old.prices.map((price: any) =>
                            price.id === id
                                ? {
                                      ...price,
                                      deactivated_labels: data.deactivated_labels,
                                      action_labels: data.action_labels,
                                  }
                                : price
                        ),
                    };
                });

                return { previousData };
            },
            onError: (_err, variables, context: any) => {
                if (context?.previousData) {
                    queryClient.setQueryData(["products", variables.data.shop_id, "cannabis"], context.previousData);
                }
            },
        }
    );
};

export const useDeleteShopPriceMutation = (shopId: string, selectedTabId: string) => {
    const queryClient = useQueryClient();

    return useMutation((id: string) => client.delete(`/v1/shops-to-prices/${id}`), {
        onSuccess: (_, deletedId) => {
            queryClient.setQueryData(["products", shopId, selectedTabId], (oldData: any) => {
                if (!oldData) return oldData;

                return {
                    ...oldData,
                    prices: oldData.prices.filter((price: Price) => price.id !== deletedId),
                };
            });
        },
        onError: (error: any) => {
            const data = error?.response;
            if (!data) return;

            if (data.status === 401) {
                throw new Error(data.statusText);
            } else {
                throw new Error(`update resulted in error ${data.status}: ${data.statusText}`);
            }
        },
    });
};
